// extracted by mini-css-extract-plugin
module.exports = {"AboutUsSectionContainer":"AboutUsSection-module--AboutUsSectionContainer--3MfBe","AboutUsSection":"AboutUsSection-module--AboutUsSection--3t4Sv"};